module.exports = __webpack_public_path__ + "static/img/products2.528c9c69.png";